import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import {
  FiArrowUpRight,
  FiHeadphones,
  FiPlay,
  FiWifi,
} from "react-icons/fi";
import WorldPhoneLogo from "./Assets/Logo-Worldphone-300x114.png";
import MaxxLogo from "./Assets/WorldMaxxLogo.svg";
import Footer from "./Components/Footer";
import Privacy from "./Screens/PrivacyPolicy/Privacy";
import RefundPolicy from "./Screens/RefundPolicy/RefundPolicy";
import Terms from "./Screens/Terms/Terms";
import "./App.css";

const CUSTOMER_LOGIN =
  "https://pkwifi.xceednet.com/subscriber/sessions/new";

const Index = () => {
  return (
    <main className="site-shell">
      <section className="hero" aria-labelledby="hero-title">
        <header className="hero-nav">
          <a className="brand" href="/" aria-label="Maxx Fibernet home">
            <img
              className="worldphone-logo"
              src={WorldPhoneLogo}
              alt="World Phone"
            />
            <span className="brand-divider" aria-hidden="true" />
            <img className="maxx-logo" src={MaxxLogo} alt="Maxx Fibernet" />
          </a>

          <a
            className="nav-login"
            href={CUSTOMER_LOGIN}
            target="_blank"
            rel="noreferrer"
          >
            Customer login
            <FiArrowUpRight aria-hidden="true" />
          </a>
        </header>

        <div className="hero-pattern" aria-hidden="true" />
        <div className="hero-content">
          <div className="eyebrow">
            <span className="eyebrow-dot" />
            Powered by World Phone
          </div>

          <h1 id="hero-title">
            Welcome to
            <span> Maxx Fibernet.</span>
            <br />
            Fast internet. Simple life.
          </h1>

          <p className="hero-copy">
            Reliable broadband built for streaming, work, gaming, and every
            screen at home.
          </p>

          <a
            className="hero-cta"
            href={CUSTOMER_LOGIN}
            target="_blank"
            rel="noreferrer"
          >
            <FiWifi aria-hidden="true" />
            Customer login
            <FiArrowUpRight className="cta-arrow" aria-hidden="true" />
          </a>

          <p className="portal-note">Manage your account, plan, and payments.</p>
        </div>

        <div className="hero-footer" aria-label="Service highlights">
          <span>High-speed broadband</span>
          <span>Reliable connectivity</span>
          <span>Entertainment ready</span>
        </div>
      </section>

      <section className="updates" aria-labelledby="updates-title">
        <div className="updates-heading">
          <p className="section-kicker">Stay connected</p>
          <h2 id="updates-title">Everything you need, in one place.</h2>
        </div>

        <div className="update-grid">
          <article className="update-card ott-card">
            <div className="update-icon" aria-hidden="true">
              <FiPlay />
            </div>
            <div>
              <p className="card-label">Entertainment</p>
              <h3>OTT plans available</h3>
              <p>
                Bring broadband and entertainment together. Contact us to
                learn more about available OTT plans.
              </p>
            </div>
          </article>

          <article className="update-card support-card">
            <div className="update-icon" aria-hidden="true">
              <FiHeadphones />
            </div>
            <div>
              <p className="card-label">Customer support</p>
              <h3>Need help in Akbarpur?</h3>
              <p>
                For any complaints related to Akbarpur, please contact the
                following number:
              </p>
              <a href="tel:+917007242003">+91-7007242003</a>
            </div>
          </article>
        </div>
      </section>

      <Footer />
    </main>
  );
};

const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Index />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/refund-policy" element={<RefundPolicy />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
